import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padded?: boolean;
}

export function Card({ children, className, padded = true, ...props }: CardProps) {
  return (
    <div className={cn("rounded-md border border-border bg-surface-2", padded && "p-4", className)} {...props}>
      {children}
    </div>
  );
}
